<template>
  <!-- 聚合页跳转到厦门国际银行-新客礼项目， 厦门国际银行-提升礼项目， 厦门国际银行-重归白金礼项目 -->
  <div class="jh-page">
    <!-- 记录规则分享 -->
    <div class="record-rule">
      <div @click="ruleVisible = true">规则</div>
      <div @click="goShare">分享</div>
      <!-- <div @click="shareGuideVisible = true">分享</div> -->
    </div>
    <div class="btn-wrapper">
      <!-- 厦门国际银行-提升礼 -->
      <div
        class="btn-item btn-item-1"
        @click="jumpDetail('xiamePromotionGift')"
      >
        <div class="btn-item-prefix">
          <img
            :src="require('@/assets/imgs/promotionGift/jhPageJimeng1.png')"
            alt=""
          />
        </div>
        <div class="btn-item-main">
          <img
            :src="require('@/assets/imgs/promotionGift/jhPageBtn1.png')"
            alt=""
          />
        </div>
      </div>
      <!-- 厦门国际银行-新客礼 -->
      <div
        class="btn-item btn-item-2"
        @click="jumpDetail('xibNewCustomerGift')"
      >
        <div class="btn-item-prefix">
          <img
            :src="require('@/assets/imgs/promotionGift/jhPageJimeng2.png')"
            alt=""
          />
        </div>
        <div class="btn-item-main">
          <img
            :src="require('@/assets/imgs/promotionGift/jhPageBtn2.png')"
            alt=""
          />
        </div>
      </div>
      <!-- 厦门国际银行-重回礼 -->
      <div class="btn-item btn-item-3" @click="jumpDetail('xibReturnGift')">
        <div class="btn-item-prefix">
          <img
            :src="require('@/assets/imgs/promotionGift/jhPageJimeng3.png')"
            alt=""
          />
        </div>
        <div class="btn-item-main">
          <img
            :src="require('@/assets/imgs/promotionGift/jhPageBtn3.png')"
            alt=""
          />
        </div>
      </div>
    </div>

    <jh-page-rule-modal :visible="ruleVisible" @confirm="ruleVisible = false" />

    <!-- 分享引导弹窗 -->
    <van-overlay
      v-model:show="shareGuideVisible"
      :lock-scroll="true"
      :z-index="300"
    >
      <div class="jh-share-guide" @click="shareGuideVisible = false">
        <img
          class="jh-share-guide__arrow"
          :src="require('@/assets/imgs/promotionGift/jhPageShare.png')"
          alt=""
        />
        <div class="jh-share-guide__steps">
          <div class="jh-share-guide__row">
            <span class="jh-share-guide__num">1</span>
            <span class="jh-share-guide__text">点击右上角的 ··· 按钮</span>
          </div>
          <div class="jh-share-guide__row jh-share-guide__row--2">
            <span class="jh-share-guide__num">2</span>
            <span class="jh-share-guide__text">选择</span>
            <span class="jh-share-guide__pill">在Safari/浏览器中打开</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { login } from "@/api/xibNewCustomerGift";
import { preloadJhPageImages } from "./components/preloadImages.js";
import JhPageRuleModal from "./components/jhPageRuleModal.vue";

export default {
  components: {
    JhPageRuleModal,
  },
  data() {
    return {
      ruleVisible: false,
      shareGuideVisible: false,
    };
  },
  async mounted() {
    await preloadJhPageImages();
    await this.handleLogin();
  },
  methods: {
    jumpDetail(type) {
      if (!sessionStorage.getItem("xiameBankPromotionJhToken")) {
        this.$toast.fail("请先登录！");
        return;
      }
      this.$router.push({
        name: type,
        // query: { token: this.$route.query.token }
      });
    },
    // 新客礼跟提升礼需求变更，登录聚合页面活动聚合，过几天会在聚合一个活动
    async handleLogin() {
      try {
        // 已登录不用登录
        if (sessionStorage.getItem("xiameBankPromotionJhToken")) {
          return;
        }
        const { token } = this.$route.query;
        if (!token) {
          this.$toast.fail("请携带访问标识！");
          return;
        }
        const { code, data } = await login({ token });
        if (code !== 0) return;
        sessionStorage.setItem("xiameBankPromotionJhToken", data.token);
      } catch (error) {
        console.log(error);
      }
    },
    // 去分享
    goShare() {
      // demo展示的情况
      let param = {
        title: "财富晋升好礼", //分享链接的标题
        desc: "-",
        // thumbnail: `https://ydsh-prod.oss-cn-hangzhou.aliyuncs.com/20250408/20250408094742HEQi.png`, //分享链接的图标
        url: `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-ph-h5-bankv3/XiameBankPromotionGiftShare`, //分享页的链接
      };
      // eslint-disable-next-line no-undef
      XIBLS.SocialShare.shareAll(
        function () {
          console.log("分享成功");
        },
        function () {
          console.log("分享失败");
        },
        param,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.jh-page {
  width: 100%;
  min-height: 100vh;
  background-color: #6f4ab0;
  background-image: url("~@/assets/imgs/promotionGift/jhPageBg.png");
  background-size: 100%;
  background-repeat: no-repeat;

  .record-rule {
    position: absolute;
    top: 20vh;
    right: 9.5px;
    font-size: 13px;
    color: #fff;
    cursor: pointer;

    div {
      width: 44.5px;
      height: 44.5px;
      background: #000000;
      border-radius: 8px;
      border: 1px solid #ffebb5;
      opacity: 0.5;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .btn-wrapper {
    position: absolute;
    bottom: 2vh;
    width: 100vw;
    padding-left: 15.5px;
    padding-right: 15.5px;
    box-sizing: border-box;

    .btn-item {
      position: relative;
      margin-top: 9px;

      .btn-item-prefix {
        width: 68px;
        height: 99px;
        position: absolute;
        bottom: 0;
      }

      .btn-item-main {
        width: 276px;
        height: 79px;
      }

      img {
        width: 100%;
      }
    }

    .btn-item-1 {
      padding-left: 15px;

      .btn-item-prefix {
        left: 0;
      }
    }

    .btn-item-2 {
      display: flex;
      flex-direction: row-reverse;
      padding-right: 16.5px;

      .btn-item-prefix {
        right: 0;
      }
    }
    .btn-item-3 {
      padding-left: 29px;

      .btn-item-prefix {
        left: 0;
      }
    }
  }

  .jh-share-guide {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    &__arrow {
      position: absolute;
      top: calc(32px + env(safe-area-inset-top, 0px));
      right: 32px;
      width: 68px;
      height: auto;
      box-sizing: content-box;
      padding: 12px;
      pointer-events: none;
    }

    &__steps {
      width: fit-content;
      max-width: min(300px, calc(100vw - 120px));
      margin: 0 auto;
      padding: calc(22vh + env(safe-area-inset-top, 0px)) 24px 0 20px;
    }

    &__row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px 10px;
      margin-bottom: 18px;
      color: #fff;
      font-size: 15px;
      line-height: 1.45;
      font-weight: 500;
    }

    &__row--2 {
      align-items: center;
    }

    &__num {
      flex-shrink: 0;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: #9256f9;
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      font-style: italic;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    &__text {
      flex-shrink: 0;
    }

    &__pill {
      flex-shrink: 0;
      border: 1px solid #fff;
      border-radius: 8px;
      padding: 4px 10px;
      background: rgba(255, 255, 255, 0.12);
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
